export const QR_ON_TABLETS_OPTIONS = {
  none: "none",
  available: "available",
  all: "all",
};

export const RETRY_COUNT = 2;
export const RETRY_DELAY = 2000;

// Without a timeout a stalled request never rejects, so neither branch of a caller's `.then`
// runs: `ongoingRefresh` is never cleared by its `.finally()` and every later non-forced refresh
// joins a promise that will never settle. Observed in production on 2026-08-18, when a midnight
// schedule fetch produced neither a completion nor an error line (DT-1103).
//
// A timeout raises `ECONNABORTED`, which axios-retry deliberately excludes from both
// `isNetworkError` and `isRetryableError`, so it is *not* retried. That is intended here: the
// failure mode this guards against is congestion, and retrying into it amplifies the problem.
// Surfacing the error immediately is what matters — it settles the promise and lets the caller's
// own recovery run (the midnight refresh reloads the page on error).
export const REQUEST_TIMEOUT = 20000;
